<template>
  <v-btn :disabled="!resettableData || resettableData.length == 0" small color="secondary lighten-1" @click="reset">
    <v-icon>settings_backup_restore</v-icon>
    Undo changes
  </v-btn>  
</template>
<script>
export default {
  props: {
    logs: Array,
  },
  computed: {
    dirtyData() {
      return this.$store.getters['reviewingestionresults/dirtyData']
    },
    resettableData () {
      return this.logs.filter(log => this.dirtyData[log.location])
    },
    locator () {
      return this.$store.getters['reviewingestionresults/locator']
    },
  },
  methods: {
    reset () {
      let logLocations = this.resettableData.map(log => log.location)
      this.$store.dispatch('reviewingestionresults/resetDirtyDatum', logLocations)
    },
  },
}
</script>